// Set jQuery globally before any plugins that need it
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;
